module.exports = __webpack_public_path__ + "img/MapThumb_PersianQuarries.4a4d0417.webp";